import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {ComponentsModule} from './components/components.module';
import {DialogsModule} from './dialogs/dialogs.module';
import {UpperCasePipe} from '@angular/common';

@NgModule({
    declarations: [

    ],
    imports: [
        RouterModule,
        ComponentsModule,
        DialogsModule
    ],
    exports: [
        ComponentsModule,
        DialogsModule,
    ],
    providers:    [ UpperCasePipe ]
})

export class FrameworkModule {
}
